import { render, staticRenderFns } from "./EditProjectAssetModal.vue?vue&type=template&id=0af97ecb"
import script from "./EditProjectAssetModal.vue?vue&type=script&lang=js"
export * from "./EditProjectAssetModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports